import { gql } from '@apollo/client';

export const MANAGE_DISTRICT_ACCOUNT = gql`
  mutation manageDistrictAccount($input: ChangeManageStatusInput!) {
    changeManageStatus(input: $input) {
      guardianId
      managedBy
    }
  }
`
